"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserController = function UserController(authService, enums) {
    "ngInject";

    (0, _classCallCheck3.default)(this, UserController);
    this.authService = authService;

    if (!authService.validateUser(false)) {
        return;
    }

    this.locations = (0, _lodash.filter)(authService.authData.userRoles, function (o) {
        return o.entityType === enums.ENTITY_TYPE.Location;
    });

    if (this.locations.length && !authService.authData.currentLocationId) {
        authService.authData.currentLocationId = this.locations[0].entityId.toString();
    }
};

exports.default = UserController;


// WEBPACK FOOTER //
// ./client/app/components/user/user.controller.js